module.exports = __webpack_public_path__ + "./kit/docs/img/video.ea1e69031410556f13afecccfdbf208b.svg";